let duBridge = null
const logoUrl =
  'https://cdn.poizon.com/node-common/7a58dbd980e075d60f0619724a912179.png'
if (process.server) {
  duBridge = {
    duSafeJockey: {
      send: Function.prototype,
      on: Function.prototype
    }
  }
}
if (process.client) {
  duBridge = require('du/jsbridge').default
}
const { duSafeJockey } = duBridge
let openNativePageDebounce = false
const AppRouteHost = 'https://m.poizon.com/router'
/**
 * 文档地址：https://poizon.feishu.cn/docs/doccnF8lmvt1CiuBCwTY6n4wmAg
 */
class Jockeys {
  constructor() {
    throw new Error('不用实例化')
  }

  /**
   * native 分享
   * @param {Object} options
   * @property {String} options.title         分享其他平台时的标题
   * @property {String} options.description   描述
   * @property {String} options.link          分享的url地址
   * @property {String} options.imgUrl        分享的图片链接，只给 instagram 用
   * @property {Array}  options.channels      0微信 1facebook 2messenger 3whats 4instagram 5copy_link 6twitter
   */
  static socialShare(options = {}) {
    !options.channels && (options.channels = [0, 1, 2, 3, 4, 5, 6])
    duSafeJockey.send('socialShare', options)
  }

  /**
   * native 右上角分享
   * @param {Object} options
   * @property {String} options.title         分享其他平台时的标题
   * @property {String} options.description   描述
   * @property {String} options.link          分享的url地址
   * @property {String} options.imgUrl        分享的图片链接
   */
  static rightBarButtonItem(options) {
    options.imgUrl = options.imgUrl || logoUrl
    duSafeJockey.off('rightBarButtonItem')
    duSafeJockey.send('rightBarButtonItem', options)
  }

  static setTitle(title) {
    if (process.server) return
    document.title = title
    duSafeJockey.send('setTitle', { title })
  }

  static login() {
    duSafeJockey.send('login')
  }

  static offEvent(eventName) {
    if (eventName) {
      return
    }
    duSafeJockey.off(eventName)
  }

  // 目前只支持黑白两色
  static setStatusBarIconColorIsDark(isDark) {
    duSafeJockey.send('setStatusBarIconColor', { isDark })
  }

  static loadIdentifyDetailData() {
    return new Promise((resolve) => {
      duSafeJockey.on('loadIdentifyDetailData', (payload, comment) => {
        resolve({ payload, comment })
      })
    })
  }

  static previewImages(index, images = []) {
    duSafeJockey.send('showContentImages', { index: Number(index), images })
  }

  static openNativePage(url, query = {}) {
    // 防抖
    if (openNativePageDebounce) return
    openNativePageDebounce = true
    let queryStr = Object.keys(query)
      .map((key) => `${key}=${query[key]}`)
      .join('&')
    queryStr = queryStr ? `?${queryStr}` : ''
    duSafeJockey.send('openNativePage', {
      routerUrl: `https://m.poizon.com/router${url + queryStr}`
    })
    setTimeout(() => (openNativePageDebounce = false), 2000)
  }

  // 启用 webview 返回拦截
  static enableHybridBack(enabled = true, type = 1) {
    duSafeJockey.send('enableHybridBack', { enabled, type })
  }

  // 点击webview返回触发回调
  static handleNativeBack(handleNativeBack) {
    duSafeJockey.on('handleNativeBack', (...args) => {
      handleNativeBack(...args)
    })
  }

  // 触发跳转到原生页面
  static loginWithPayal(authUrl) {
    duSafeJockey.send('loginWithPayal', { authUrl })
  }

  // 跳转原生绑定 PayPal
  static bindPaypal(isChangePaypal = false) {
    duSafeJockey.send('bindPaypal', { isChangePaypal })
  }

  // 触发 paypal 回调
  static loginWithPayalCallback(fun) {
    duSafeJockey.on('loginWithPayalCallBack', (args) => {
      fun(args)
    })
  }

  /**
   * webview返回拦截并注册返回的回调
   * @param {*} fun
   * @param {*} param1
   * @return 取消监听
   */
  static registerNativeBack(fun, { enabled = true, type = 1 }) {
    duSafeJockey.send('enableHybridBack', { enabled, type })
    duSafeJockey.on('handleNativeBack', (...args) => {
      fun(...args)
    })
  }

  static offNativeBack() {
    duSafeJockey.send('enableHybridBack', { enabled: false, type: 1 })
    // TODO off 现有API off会将所有回调都off掉 目前前端做逻辑
    // duSafeJockey.off('handleNativeBack')
  }

  // 关闭当前webview  succeed 业务相关 true 的话表示业务流程处理正确
  static closeCurrentPage(succeed = false) {
    duSafeJockey.send('closeCurrentPage', { succeed })
  }

  // webview focus 处理页面是否需要刷新
  static refreshHybridData(refreshHybridData) {
    duSafeJockey.on('refreshHybridData', (...args) => {
      refreshHybridData(...args)
    })
  }

  static setLocalData(key, value) {
    duSafeJockey.send('setLocalData', {
      [key]: value
    })
  }

  static getLocalData(fn) {
    duSafeJockey.on('getLocalData', function(params) {
      fn(params)
    })
  }

  static needLocalData() {
    duSafeJockey.send('needLocalData')
  }

  // 设置webview 右上角链接展示
  static registerBarAction({
    actionName,
    routerUrl,
    iconUrl = '',
    // 可以设置多个
    saveBoth = false
  }) {
    duSafeJockey.send('registerBarAction', {
      actionName,
      routerUrl: `https://m.poizon.com/router/web/browser?url=${routerUrl}`,
      iconUrl,
      saveBoth
    })
  }

  /**
   * 2.6.510 IOS 之后注册 Bar & Action 包含分享
   * 1. 路由；2. 分享
   * @param {Array<BarAction|ShareAction>} list
   * @interface ShareAction  {
   *    "title":"标题1",
   *    "description":"描述",
   *    "link":"分享用的链接",
   *    "imgUrl":"图片链接"
   *    "type": 2
   * }
   * @interface BarAction{
   *    "title":"标题1",
   *    "iconUrl":"按钮图片",
   *    "link":"路由"
   *    "nativeRoute": "跳转原生的内容" 默认走/web/browser
   *    "type": 1
   * }
   */
  static setNavigationBarButtonList(list) {
    if (!Array.isArray(list) || list.length === 0) throw new Error('参数错误')
    if (list.length > 3) throw new Error('最多支持3个bar')

    list = list.map((item) => {
      if (item.type === 1) {
        const url = item.nativeRoute || '/web/browser'
        const queryStr = Object.entries(item.link || {})
          .map(([item, value]) => {
            if (item === 'url') value = encodeURIComponent(value)
            return `${item}=${value}`
          })
          .join('&')

        item.link = `${AppRouteHost}${url}?${queryStr}`
      }
      return item
    })

    duSafeJockey.send('setNavigationBarButtonList', { list })
  }

  static destoryNavigationBarButtonList() {
    duSafeJockey.send('setNavigationBarButtonList', { list: [] })
  }

  /**
   * @returns { {actionName, routerUrl, iconUrl} }
   */
  static handleRightBarButtonItem(fun) {
    duSafeJockey.off('handleRightBarButtonItem')
    duSafeJockey.on('handleRightBarButtonItem', function(info) {
      fun(info)
    })
  }

  /**
   * @returns { {shareStatus, shareChannel} } shareStatus 0 - 成功；1 - 失败；2 - 取消； shareChannel 代表分享渠道；
   */
  static handleShareResult(fun) {
    duSafeJockey.off('handleShareResult')
    duSafeJockey.on('handleShareResult', function(shareInfo) {
      fun(shareInfo)
    })
  }

  // app去设置系统通知
  static enableNativePush() {
    duSafeJockey.send('enableNativePush')
  }

  // app push权限状态变更的监听钩子 notificationState 开启状态，0 关闭，1 开启
  static getNotificationState(fun) {
    duSafeJockey.on('getNotificationState', function({ notificationState }) {
      fun(notificationState)
    })
  }

  // 打开邮箱
  static sendEmailTo(targetEmail) {
    duSafeJockey.send('sendEmailTo', { targetEmail })
  }

  // 修改银行账户
  /**
   * type: int. 账户类型
   * • 1   Paypal账户
   * • 2   银行卡账户
   * account: String. 账户号码
   */
  static changePayAccount(options) {
    duSafeJockey.send('changePayAccount', options)
  }

  // 绑定用户
  static CallBindingAccount(options) {
    duSafeJockey.send('CallBindingAccount', options)
  }

  static setStatusBarTransparent(data) {
    duSafeJockey.send('setStatusBarTransparent', {
      isTransparent: data
    })
    // 设置状态栏是否透明 1透明，0不透明
  }

  static getPlatformInfoCallback(...args) {
    duSafeJockey.on('getPlatformInfoCallback', ...args)
  }

  static getPlatformInfo(...args) {
    duSafeJockey.send('getPlatformInfo', ...args)
  }

  /**
   * 获取airwallex支付初始化数据
   * @param {*} fn
   */
  static getAirwallexConfig(fn) {
    duSafeJockey.send('getAirwallexConfig')
    duSafeJockey.on('getAirwallexConfigCallback', function(params) {
      // console.log('getAirwallexConfigCallback', params)
      fn(params)
    })
    // setTimeout(() => {
    //   fn({
    //     intentId: "int_hkdmgdvpjg0mv054t2n",
    //     clientSecret: 'eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MjY3NTA4MDcsImV4cCI6MTYyNjc1NDQwNywiYWNjb3VudF9pZCI6IjMyMjM4MDQzLTEwZTUtNGYwYi1hMmUzLTRjM2E3YThmNmViZSIsImRhdGFfY2VudGVyX3JlZ2lvbiI6IkhLIiwiaW50ZW50X2lkIjoiaW50X2hrZG1nZHZwamcwbXYwNTR0Mm4iLCJjdXMiOiJjdXNfaGtkbWdkdnBqZzBtdXpjYW11ZCJ9.gHAWRNyn4se86uC1bYuPzagjKP4z5u6f6NiJSe86Mn0',
    //     customerId: 'cus_hkdmgdvpjg0muzcamud',
    //     currency: 'HKD',
    //     payTotal: "100",
    //     poizonPaymentMethod: "airwallex",
    //     orderNum: "111100001602490834",
    //     payLogNum: "",
    //     spuId: "30001404",
    //     paymentConsentId: 'cst_hkdmhpqb6g0mv2913q4',
    //     cardNo: "**** **** **** 5454",
    //   })
    // }, 0)
  }

  /**
   * airwallex支付状态-成功/失败
   * @param {*} options
   */
  static airwallexPaySendStatus(options) {
    duSafeJockey.send('airwallexPaySendStatus', options)
  }

  // 点击申请商品上架
  static pushNewProductApply() {
    duSafeJockey.send('pushNewProductApply')
  }

  // 发送获取新客服开关
  static sendCustomerServiceSwitchRetrieval() {
    console.log('send getImSwitch')
    duSafeJockey.send('getImSwitch')
  }

  static callPhone(tel) {
    duSafeJockey.send('call', tel)
  }

  // 获取新客服开关
  static getCustomerServiceSwitch(callback) {
    duSafeJockey.on('getImSwitchCallback', callback)
  }
}
export default Jockeys
